angular.module('unica_invitation_list.invitation_list_services')

.factory('InvitationListEditService', function ($http, getBaseApiURL) {

	var invitationListEditService = {};

	invitationListEditService.update = function (invitationListData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});

	};

	return invitationListEditService;
});